export const base_path = '/customer'
export const topics_path = `${base_path}/topics`
export const topicDetails_path = `${base_path}/topic-detail`
export const contacts_path = `${base_path}/contacts`
export const contactDetails_path = `${base_path}/contact-detail`